export function chatVisibleToViewer(message: { channel?: string; campaign_id?: string; encounter_id?: string | null;
    from_user_id?: string; recipient_ids?: string[] }, userId: string, gm: boolean, campaignId: string, encounterId: string): boolean {
    const upper = (v: unknown): string => String(v ?? '').toUpperCase();
    if (upper(message.campaign_id) !== upper(campaignId)) return false;
    if (message.channel === 'ooc') return true;
    const privateLine = message.channel === 'whisper' || message.channel === 'gm';
    if (!privateLine && upper(message.encounter_id) !== upper(encounterId)) return false;
    if (upper(message.from_user_id) === upper(userId) || gm) return true;
    if (privateLine || (message.channel === 'say' && message.recipient_ids?.length))
        return message.recipient_ids?.some(id => upper(id) === upper(userId)) === true;
    return true;
}
